import React from 'react';
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center py-6">
            <div className="flex items-center space-x-4">
              <Button
                onClick={() => navigate(-1)}
                className="bg-gradient-to-r from-[#3887FF] to-[#9F2BF6] hover:opacity-90 text-white px-4 py-2 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                <ArrowLeft className="h-5 w-5 mr-2" />
                Back
              </Button>
              <h1 className="text-2xl font-semibold text-gray-900">Privacy Statement</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="max-w-3xl mx-auto">
          <div className="prose prose-lg space-y-6 text-gray-700">
            <p className="leading-relaxed">
              Welcome to our platform, where knowledge and resources come together to foster growth and collaboration. 
              Our primary mission is to share experiences and templates with everyone, empowering individuals and 
              organizations to excel in their respective fields. We are a nonprofit initiative committed to building 
              a thriving community of knowledge-sharing and learning.
            </p>
            
            <p className="leading-relaxed">
              To ensure the best experience for all users, we kindly request that you share the link to our resources 
              instead of downloading and redistributing files directly. This helps us expand our reach and create a 
              broader community of individuals dedicated to sharing knowledge and experiences.
            </p>
            
            <h2 className="text-2xl font-semibold text-[#1e3a8a] mt-8 mb-4">
              Free Service for Building a Community
            </h2>
            <p className="leading-relaxed">
              Our platform will remain completely free during this initial phase as we focus on growing a large and 
              vibrant community. Once we achieve this goal, we plan to introduce a one-time subscription fee, designed 
              to sustain the platform and ensure its longevity. This subscription will act as a community fund, 
              supporting the ongoing mission of sharing knowledge and maintaining this invaluable resource for future members.
            </p>
            
            <h2 className="text-2xl font-semibold text-[#1e3a8a] mt-8 mb-4">
              Our Commitment
            </h2>
            <ul className="list-disc pl-6 space-y-4">
              <li>
                <strong>Privacy Protection:</strong> Your privacy is our priority. We do not collect personal data 
                beyond what is necessary to provide you with seamless access to our platform.
              </li>
              <li>
                <strong>Data Sharing:</strong> Any templates or resources you access through this platform are intended 
                for personal and professional use. Redistribution without appropriate permissions is discouraged to 
                uphold the integrity of the community.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#1e3a8a] mt-8 mb-4">
              Building a Sustainable Knowledge Network
            </h2>
            <p className="leading-relaxed">
              By adhering to these guidelines, you contribute to a movement focused on growth, learning, and sharing. 
              Together, we can create a self-sustaining community that thrives on collective effort and mutual support.
            </p>
            
            <p className="leading-relaxed font-medium mt-8">
              Thank you for being part of our journey. Let's collaborate, share, and grow—together.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
